/*
  CRO2610 plant styling page.
  1. The three option cards choose the booking in the booking app's calendar (its own "choose a variant" list),
     and follow it when the visitor changes that list by hand.
  2. Any link with data-ps-pick="<n>" picks option n and scrolls to the calendar (or to the option's card when
     that option is a plain link, such as the free call before it is set up in the booking app).
  3. The bar at the bottom shows once the hero button has scrolled away and hides while the booking block is in view.
  4. Videos start when they come into view and stop when they leave.
  6. On the custom planters page: a shape tile or a colour swatch fills in its field in the quote form, and
     the form opens WhatsApp with every answer typed as one message.
  7. Before and after pictures on a card: dragging the handle shows more of one or the other.
  8. The quiz: three questions, then one suggestion, with a WhatsApp message written from the answers.
  5. If the booking app has not drawn its calendar about 12 seconds after the page opened, a note with a
     WhatsApp button shows in its place; it goes away if the calendar turns up later.
  Without this script the page still works: the calendar shows the booking app's own list of options.
*/
(function () {
  if (window.__ps26) return;
  window.__ps26 = true;
  var all = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var one = function (s, r) { return (r || document).querySelector(s); };

  function start() {
    var book = one('[data-ps-book]');
    var cards = all('[data-ps-option]');
    var label = one('[data-ps-picked]');

    function mark(card) {
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-picked', on);
        var b = one('[data-ps-choose]', c);
        if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (label && card) {
        var pre = label.getAttribute('data-ps-picked');
        var what = document.createElement('span');
        what.innerHTML = card.getAttribute('data-ps-label') || '';
        label.textContent = pre ? pre + ' ' : '';
        label.appendChild(what);
      }
    }
    // the booking app draws its list late, so wait for it (up to about 15 seconds)
    function setList(id, tries) {
      var sel = document.getElementById('appointo-variant-select');
      if (!sel) { if ((tries || 0) < 60) setTimeout(function () { setList(id, (tries || 0) + 1); }, 250); return; }
      if (sel.value === String(id)) return;
      var has = Array.prototype.some.call(sel.options, function (o) { return o.value === String(id); });
      if (!has) return;
      sel.value = String(id);
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function pick(n, scroll) {
      var card = cards[n - 1];
      if (!card) { if (scroll && book) book.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      var id = card.getAttribute('data-ps-variant');
      if (!id) { if (scroll) card.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      mark(card);
      setList(id);
      if (scroll) { var cal = one('[data-ps-cal]') || book; if (cal) cal.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-ps-pick], [data-ps-choose]') : null;
      if (!t) return;
      var n;
      if (t.hasAttribute('data-ps-choose')) n = cards.indexOf(t.closest('[data-ps-option]')) + 1;
      else n = parseInt(t.getAttribute('data-ps-pick'), 10) || 0;
      if (!cards.length) return; // no booking block on this page: let the link work as a link
      e.preventDefault();
      if (n) pick(n, true); else if (book) book.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    document.addEventListener('change', function (e) {
      if (!e.target || e.target.id !== 'appointo-variant-select') return;
      var card = cards.filter(function (c) { return c.getAttribute('data-ps-variant') === e.target.value; })[0];
      if (card) mark(card);
    });
    // start on the option marked as the default, so the calendar opens with dates to choose from
    var first = cards.filter(function (c) { return c.hasAttribute('data-ps-default') && c.getAttribute('data-ps-variant'); })[0];
    if (first) { mark(first); setList(first.getAttribute('data-ps-variant')); }

    // custom planters: tiles and swatches fill in the quote form; the form can go out by WhatsApp
    var quote = one('form[data-ps-quote]');
    var field = function (name) { return quote ? quote.querySelector('[name="contact[' + name + ']"]') : null; };
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-ps-set]') : null;
      if (!t) return;
      var name = t.getAttribute('data-ps-set'), value = t.getAttribute('data-ps-value');
      all('[data-ps-set="' + name + '"]').forEach(function (x) { x.classList.toggle('is-on', x === t); });
      var f = field(name);
      if (!f) return;
      var has = Array.prototype.some.call(f.options || [], function (o) { return o.value === value; });
      if (f.options && !has) { var o = document.createElement('option'); o.value = value; o.textContent = value; f.appendChild(o); }
      f.value = value;
      if (name === 'Shape') (one('.ps26-quote-sec') || quote).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    if (quote) {
      quote.addEventListener('change', function (e) {
        var m = /^contact\[(.+)\]$/.exec(e.target.name || '');
        if (!m || !e.target.options) return;
        all('[data-ps-set="' + m[1] + '"]').forEach(function (x) { x.classList.toggle('is-on', x.getAttribute('data-ps-value') === e.target.value); });
      });
      // the form goes out as one WhatsApp message with every answer typed in
      var message = function () {
        var v = function (n) { var f = field(n); return f && f.value ? String(f.value).trim() : ''; };
        var checked = function (n) { var c = quote.querySelector('[name="contact[' + n + ']"]:checked'); return c ? c.value : ''; };
        var lines = [quote.getAttribute('data-ps-wa-hello') || 'Hi, I would like a quote for a custom planter.', ''];
        var size = [v('Length cm'), v('Width cm'), v('Height cm')];
        if (v('Shape')) lines.push('Shape: ' + v('Shape'));
        if (size.join('')) lines.push('Size (L x W x H): ' + size.map(function (x) { return x || '?'; }).join(' x ') + ' cm');
        if (v('Quantity')) lines.push('How many: ' + v('Quantity'));
        if (v('Colour or finish')) lines.push('Colour or finish: ' + v('Colour or finish'));
        if (checked('Where')) lines.push('Where: ' + checked('Where'));
        var extras = all('input[type="checkbox"]:checked', quote).map(function (c) { return (/^contact\[(.+)\]$/.exec(c.name) || [])[1]; }).filter(Boolean);
        if (extras.length) lines.push('Extras: ' + extras.join(', '));
        if (checked('Plants')) lines.push('Plants: ' + checked('Plants'));
        if (v('Needed by')) lines.push('Needed by: ' + v('Needed by'));
        if (v('name')) lines.push('Name: ' + v('name'));
        if (v('Notes')) lines.push('Notes: ' + v('Notes'));
        return 'https://wa.me/' + quote.getAttribute('data-ps-wa') + '?text=' + encodeURIComponent(lines.join('\n'));
      };
      quote.addEventListener('submit', function (e) {
        e.preventDefault();
        var url = message();
        var w = window.open(url, '_blank');
        if (w) { try { w.opener = null; } catch (x) {} } else window.location.href = url;
        var after = one('[data-ps-wa-after]', quote);
        if (after) { after.hidden = false; var a = one('a', after); if (a) a.href = url; }
      });
    }

    // quiz: one question at a time, then one suggestion (the rule is written out in sections/cro2610-ps-quiz.liquid)
    all('[data-ps-quiz]').forEach(function (quiz) {
      var steps = all('[data-ps-q]', quiz), results = all('[data-ps-result]', quiz);
      var back = one('[data-ps-quiz-back]', quiz), again = one('[data-ps-quiz-again]', quiz);
      var picked = [];
      var show = function (n) {
        steps.forEach(function (st, i) { st.hidden = i !== n; });
        results.forEach(function (r) { r.hidden = true; });
        if (back) back.hidden = n === 0;
        if (again) again.hidden = true;
      };
      var finish = function () {
        var a = picked.map(function (p) { return p.n; });
        var key = a[0] === 3 ? 'onsite' : a[1] === 1 ? 'store' : a[1] === 2 ? (a[2] === 1 ? 'store' : 'free') : (a[0] === 1 ? 'free' : 'virtual');
        steps.forEach(function (st) { st.hidden = true; });
        results.forEach(function (r) { r.hidden = r.getAttribute('data-ps-result') !== key; });
        var res = results.filter(function (r) { return r.getAttribute('data-ps-result') === key; })[0];
        var wa = res ? one('[data-ps-quiz-wa]', res) : null;
        if (wa) {
          var lines = [quiz.getAttribute('data-ps-hello') || 'Hi, I took the plant styling quiz.', ''];
          picked.forEach(function (p) { lines.push(p.q + ' ' + p.text); });
          lines.push('', (quiz.getAttribute('data-ps-suggest') || 'Suggested for me:') + ' ' + one('[data-ps-result-title]', res).textContent.trim());
          wa.href = 'https://wa.me/' + quiz.getAttribute('data-ps-wa') + '?text=' + encodeURIComponent(lines.join('\n'));
        }
        if (back) back.hidden = true;
        if (again) again.hidden = false;
      };
      quiz.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-ps-a], [data-ps-quiz-back], [data-ps-quiz-again]') : null;
        if (!t) return;
        if (t.hasAttribute('data-ps-quiz-again')) { picked = []; show(0); return; }
        if (t.hasAttribute('data-ps-quiz-back')) { picked.pop(); show(picked.length); return; }
        var st = t.closest('[data-ps-q]');
        picked[steps.indexOf(st)] = { n: parseInt(t.getAttribute('data-ps-a'), 10), text: t.textContent.trim(), q: one('[data-ps-q-title]', st).textContent.trim() };
        picked.length = steps.indexOf(st) + 1;
        if (picked.length < steps.length) show(picked.length); else finish();
      });
    });

    // before and after pictures: the handle follows the hidden slider
    document.addEventListener('input', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-ps-ba')) e.target.parentNode.style.setProperty('--ps-ba', e.target.value + '%');
    });

    var wait = one('[data-ps-cal-wait]');
    if (wait) {
      var drawn = function () { return !!document.getElementById('appointo-modal-content'); };
      setTimeout(function () {
        if (drawn()) return;
        wait.hidden = false;
        var again = setInterval(function () { if (drawn()) { wait.hidden = true; clearInterval(again); } }, 1000);
        setTimeout(function () { clearInterval(again); }, 120000);
      }, 12000);
    }

    var bar = one('[data-ps-bar]');
    if (bar && 'IntersectionObserver' in window) {
      var cta = one('[data-ps-hero-cta]');
      var past = !cta, atBook = false, atQuiz = false, quiz = one('[data-ps-finder]');
      // the bar steps aside while the booking block or the style quiz (where its button can lead) is on screen
      var upd = function () { var on = past && !atBook && !atQuiz; bar.classList.toggle('is-on', on); document.documentElement.classList.toggle('ps26-bar-on', on); };
      if (quiz) new IntersectionObserver(function (es) { es.forEach(function (x) { atQuiz = x.isIntersecting; upd(); }); }, { rootMargin: '-25% 0px -10% 0px' }).observe(quiz);
      if (cta) new IntersectionObserver(function (es) { es.forEach(function (x) { past = !x.isIntersecting && x.boundingClientRect.top < 0; document.documentElement.classList.toggle('ps26-cta-on', x.isIntersecting && !!cta.closest('.ps26-hero--pic')); upd(); }); }).observe(cta);
      if (book) new IntersectionObserver(function (es) { es.forEach(function (x) { atBook = x.isIntersecting; upd(); }); }, { rootMargin: '-25% 0px -10% 0px' }).observe(book);
      upd();
    }

    var vids = all('video[data-ps-video]');
    if (vids.length) {
      // Clips play by themselves, silently, and never show a play button (Sam, 2026-10-14). Only a browser that asks
      // to save data (or a very old one) keeps the still pictures.
      var still = (navigator.connection && navigator.connection.saveData) || !('IntersectionObserver' in window);
      if (!still) {
        var onScreen = [], waiting = false;
        var begin = function (v) {
          if (!v.getAttribute('src') && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function (err) { if (err && err.name === 'NotAllowedError') hold(); });
        };
        // a phone in low power mode will not start a clip until the visitor touches the page: start them at that touch
        var hold = function () {
          if (waiting) return; waiting = true;
          var go = function () {
            document.removeEventListener('touchend', go, true); document.removeEventListener('click', go, true);
            waiting = false; onScreen.forEach(begin);
          };
          document.addEventListener('touchend', go, true); document.addEventListener('click', go, true);
        };
        // A phone keeps only a few clips going at once. So a clip takes its file when it comes on screen, pauses when it
        // leaves, and gives the file back once it is far away (the picture under it shows again).
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (x) {
            var v = x.target, i = onScreen.indexOf(v);
            if (x.isIntersecting) { if (i < 0) onScreen.push(v); begin(v); }
            else { if (i > -1) onScreen.splice(i, 1); if (!v.paused) v.pause(); }
          });
        }, { threshold: 0.3 });
        var far = new IntersectionObserver(function (es) {
          es.forEach(function (x) {
            var v = x.target;
            if (x.isIntersecting || !v.getAttribute('src')) return;
            v.pause(); v.classList.remove('is-playing'); v.removeAttribute('src');
            try { v.load(); } catch (e) {}
          });
        }, { rootMargin: '120% 0px 120% 0px' });
        vids.forEach(function (v) { v.addEventListener('playing', function () { v.classList.add('is-playing'); }); io.observe(v); far.observe(v); });
      }
    }

    // The customer clips on this page (section cro2610-ugc-videos, run by assets/cro2610.js): on a computer they
    // play while on screen here, where elsewhere they wait for the pointer. Their play button is hidden in cro2610-ps.css.
    var pointer = !!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches);
    var clips = pointer && 'IntersectionObserver' in window ? all('[id$="__ps_ugc"] .tw-ugc__card') : [];
    if (clips.length) {
      var uo = new IntersectionObserver(function (es) {
        es.forEach(function (x) {
          var v = x.target.querySelector('video'); if (!v) return;
          if (x.isIntersecting) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); x.target.classList.add('is-playing'); }
          else { v.pause(); x.target.classList.remove('is-playing'); }
        });
      }, { threshold: 0.6 });
      clips.forEach(function (c) { uo.observe(c); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
